import logo from './logo.svg';
import './App.css';
import Navigation from './components/Navigation';
import Background from './route/Background';
import { Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Appreciate from './route/Appreciate';

function App() {
  return (
    <div className="App">
      <Navigation></Navigation>

      <Routes>
        <Route path="/" element={<Background />} />
      </Routes>

      <Routes>
        <Route path="/Appreciateq" element={<Appreciate />} />
      </Routes>
    </div>
  );
}

//수정해야될것: 페이지 전환시 애니메이션적용  ,
// 작품감상 버튼클릭시 최상단이동  ,
// 작품감상에서 새로고침시 스크롤바 나타나는현상 쿠키나 웹스토리지를 사용하여 body의 id값 유지되게만들기
// 슬라이드 이동시 최적화

export default App;
